import { computed } from '@vue/composition-api';
import deepmerge from 'deepmerge';
import { useStore } from '@/core/store';

export default function useGetPrerequisites (locationId) {
  const store = useStore();

  const location = computed(() => store.getters['entities/Location'](locationId));

  const bookings = computed(() => store.getters.locationBookings(locationId).map(booking => deepmerge({}, booking)));

  const currentTime = computed(() => store.getters.currentTime);

  return {
    location,
    bookings,
    currentTime,
  };
}
